import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Form, Modal, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import RequestHeaderMini from './RequestHeaderMini';
import AsyncSelect from 'react-select/async';
import * as Picklist from "../Picklist";
import Master_individual_profile from '../master/Master_individual_profile';

function Tcs_Gst_Charges(props) {
    const navigate = useNavigate();

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [entityType] = useState(sessionStorage.entityType);

    const [userRight, setUserRight] = useState([]);


    const [reqRemitterType, setReqRemitterType] = useState("I");
    const [reqRemitterName, setReqRemitterName] = useState("");
    const [reqRemitterDob, setReqRemitterDob] = useState(new Date());
    const [reqPanFatherName, setReqPanFatherName] = useState("");

    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);

    const [reqSubPurpose, setReqSubPurpose] = useState("0");
    const [ddReqSubPurposeOptions, setDdReqSubPurposeOptions] = useState([]);
    const [reqPan, setReqPan] = useState("");
    const [reqNameOnPan, setReqNameOnPan] = useState("");
    const [reqPanRelation, setReqPanRelation] = useState("0");
    const [ddReqPanRelationOptions, setDdReqPanRelationOptions] = useState([]);
    const [reqPanOthRelation, setReqPanOthRelation] = useState("");

    const [reqItr2Year, setReqItr2Year] = useState("0");
    const [reqSourceOfFund, setReqSourceOfFund] = useState("S");
    const [reqDisbInstName, setReqDisbInstName] = useState("");
    const [reqDisbAmount, setReqDisbAmount] = useState("");

    const [reqNostroType, setReqNostroType] = useState("0");

    const [reqMobile, setReqMobile] = useState("");
    const [reqEmail, setReqEmail] = useState("");
    const [reqSellRate, setReqSellRate] = useState("");

    const [reqTcsFinal, setReqTcsFinal] = useState(1);
    const [reqData, setReqData] = useState([]);

    const [reqTCSInr, setReqTCSInr] = useState(0);
    const [reqBankChargesInr, setReqBankChargesInr] = useState(0);
    const [reqNostroChargesInr, setReqNostroChargesInr] = useState(0);
    const [reqGstInr, setReqGstInr] = useState(0);
    const [reqRoundOff, setReqRoundOff] = useState(0);
    //const [reqPaymentApproved, setReqPaymentApproved] = useState(0);
    const [reqRemitterAcctNo, setReqRemitterAcctNo] = useState("");
    const [reqRemitterAcctIfsc, setReqRemitterAcctIfsc] = useState("");

    const [reqRemitterBankCode, setReqRemitterBankCode] = useState("0");
    const [reqRemitterBankOptions, setDdReqRemitterBankOptions] = useState([]);

    const [fxTranNo, setFxTranNo] = useState("");
    const [calcTcs, setCalcTcs] = useState(0);
    const [calcSrvChrg, setCalcSrvChrg] = useState(0);
    const [calcGst, setCalcGst] = useState(0);
    const [calcRoundOff, setCalcRoundOff] = useState(0);
    const [orderDate, setOrderDate] = useState("");

    const [showFetchTransaction, setShowFetchTransaction] = useState(false);
    const [backOfficeData, setBackOfficeData] = useState([]);

    const [showChangeQuantity, setShowChangeQuantity] = useState(false);
    const [reqNewQuantity, setReqNewQuantity] = useState(0);
    const [rightChngQty, setRightChngQty] = useState([]);

    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [showPaymentLinkBox, setShowPaymentLinkBox] = useState(false);

    const [rightPg, setRightPg] = useState([]);

    //const [reqDocVerify, setReqDocVerify] = useState("U");
    const [reqDocId, setReqDocId] = useState("0");
    const [ddReqDocOptions, setDdReqDocOptions] = useState([]);
    const [reqDocRemark, setReqDocRemark] = useState("");
    const [docListData, setDocListData] = useState([]);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    // const [reqDocumentsFinal, setReqDocumentsFinal] = useState(0);

    const [rightPaymentLinkReq, setRightPaymentLinkRequest] = useState(0);

    const [pickedCorporate, setPickedCorporate] = useState(null);
    const [pickedIndividual, setPickedIndividual] = useState(null);
    const [reqBranch, setReqBranch] = useState("0");
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [scrIndividual, setScrIndividual] = useState("");

    const [reqIgstInr, setReqIgstInr] = useState(0);
    const [reqSgstInr, setReqSgstInr] = useState(0);
    const [reqCgstInr, setReqCgstInr] = useState(0);

    const [reqTCSRate, setReqTCSRate] = useState(0);
    const [reqTCSTaxable, setReqTCSTaxable] = useState(0);

    const [forexAmount, setForexAmount] = useState(0);
    const [totalInr, setTotalInr] = useState(0);

    const [reqRemitterAddress, setReqRemitterAddress] = useState("");
    const [reqRemitterCity, setReqRemitterCity] = useState("");
    const [reqRemitterIdType, setReqRemitterIdType] = useState("0");
    const [reqRemitterIdNo, setReqRemitterIdNo] = useState("");
    const [reqTcsSelfDecInr, setReqTcsSelfDecInr] = useState(0);
    const [reqIsd, setReqIsd] = useState("0");
    const [reqQuantity, setReqQuantity] = useState("0");
    const [reqGstTaxableValue, setReqGstTaxableValue] = useState("0");
    const [acRemark, setAcRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [riskValue, setRiskValue] = useState("0");
    const [riskModalBoxText, setRiskModalBoxText] = useState("");
    const [pickedExecutive, setPickedExecutive] = useState(null);
    const [executiveName, setExecutiveName] = useState(null);
    const [executiveId, setExecutiveId] = useState(null);
    const [pickedSubExecutive, setPickedSubExecutive] = useState(null);
    const [subExecutiveName, setSubExecutiveName] = useState(null);
    const [subExecutiveId, setSubExecutiveId] = useState(null);
    const [reqRemPan, setReqRemPan] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'TCSFINAL'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setReqData(resp1);
                        setReqIsd(resp1.req_isd);
                        setReqQuantity(resp1.req_quantity);
                        setReqPurpose(resp1.req_purpose);
                        setReqBranch(resp1.req_brnno);
                        setReqTcsFinal(resp1.req_tcsfinal);
                        setReqTCSInr(resp1.req_tcs);
                        setReqBankChargesInr(resp1.req_bankcharges);
                        setReqNostroChargesInr(resp1.req_nostrocharges);
                        setReqGstInr(resp1.req_gst);
                        setReqRoundOff(resp1.req_roundoff);
                        setReqRemitterType(resp1.req_remittertype);
                        setReqRemitterName(resp1.req_remittername);
                        if (resp1.req_remitterdob !== null) {
                            setReqRemitterDob(new Date(resp1.req_remitterdob));

                        }
                        setReqPanFatherName(resp1.req_panfathername);
                        setReqPan(resp1.req_pan);
                        setReqNameOnPan(resp1.req_nameonpan);
                        setReqPanRelation(resp1.req_panrelation);
                        setReqPanOthRelation(resp1.req_panothrelation);
                        setReqItr2Year(resp1.req_itr2year);
                        setReqSourceOfFund(resp1.req_sourceoffund);
                        setReqDisbInstName(resp1.req_disbinstname);
                        setReqDisbAmount(resp1.req_disbamount);
                        setReqMobile(resp1.req_mobile);
                        setReqEmail(resp1.req_email);
                        setReqNostroType(resp1.req_nostrotype);
                        setReqSellRate(resp1.req_sellrate);
                        setReqRemitterAcctNo(resp1.req_remitteracctno);
                        setReqRemitterAcctIfsc(resp1.req_remitteracctifsc);
                        setReqRemitterBankCode(resp1.req_remitterbankcode);
                        setReqRemitterAddress(resp1.req_remitteraddress);
                        setReqRemitterCity(resp1.req_remittercity);
                        setReqRemitterIdType(resp1.req_remitteridtype);
                        setReqRemitterIdNo(resp1.req_remitteridno);
                        if (resp1.req_executive) {
                            setPickedExecutive({
                                id: '^' + resp1.req_executive + '^' + resp1.req_executive_name + '^',
                                label: ' ' + resp1.req_executive + ' ' + resp1.req_executive_name + ' '
                            })
                        }
                        if (resp1.req_sub_executive) {
                            setPickedSubExecutive({
                                id: '^' + resp1.req_sub_executive + '^' + resp1.req_sub_executive_name + '^',
                                label: ' ' + resp1.req_sub_executive + ' ' + resp1.req_sub_executive_name + ' '
                            })
                        }
                        setExecutiveId(resp1.req_executive);
                        setExecutiveName(resp1.req_executive_name);
                        setSubExecutiveId(resp1.req_sub_executive);
                        setSubExecutiveName(resp1.req_sub_executive_name);
                        //setReqDocumentsFinal(resp1.req_documentsfinal);
                        setDocListData(resp1.req_documentdetail);
                        // setReqPurpose(resp1.req_purpose);
                        setReqSubPurpose(resp1.req_subpurpose);
                        // setReqBranch(resp1.req_brnno);
                        setReqCgstInr(resp1.req_cgst * 1);
                        setReqSgstInr(resp1.req_sgst * 1);
                        setReqIgstInr(resp1.req_igst * 1);
                        setReqTCSRate(resp1.req_tcs_rate * 1);
                        setReqTCSTaxable(resp1.req_tcs_taxable * 1);
                        setReqTcsSelfDecInr(resp1.req_tcsselfdeclare);
                        setReqGstTaxableValue(resp1.req_taxablevalue);
                        setReqRemPan(resp1.req_remitter_pan);

                        const totalgst = resp1.req_gst * 1;
                        const forexamt = Math.round(resp1.req_sellrate * resp1.req_quantity);
                        let totalInv = ((resp1.req_sellrate * resp1.req_quantity).toFixed(2) * 1 + resp1.req_tcs * 1 + totalgst + resp1.req_bankcharges * 1 + resp1.req_nostrocharges * 1 + resp1.req_roundoff * 1).toFixed(2);
                        setForexAmount(forexamt);
                        setTotalInr(totalInv);
                        if (Common.showPickList) {
                            const totalgst1 = resp1.req_cgst * 1 + resp1.req_sgst * 1 + resp1.req_igst * 1;
                            const totalInv1 = (forexamt + resp1.req_tcs * 1 + totalgst1 + resp1.req_bankcharges * 1 + resp1.req_nostrocharges * 1).toFixed(2);
                            console.log(totalInv1);
                            let roundInv = Math.round(totalInv1);
                            let roundoff = (roundInv - totalInv).toFixed(2);
                            setForexAmount(resp1.req_sellrate * resp1.req_quantity);
                            setTotalInr(roundInv);
                            if (!isNaN(roundoff) && typeof roundoff !== 'undefined') {
                                setReqRoundOff(roundoff);
                            }
                            // if (typeof roundoff === 'number') {
                            //     setReqRoundOff(roundoff);
                            // }
                            // console.log(roundoff);
                        }

                        if (resp1.indsrno != "0") setPickedIndividual(JSON.parse(resp1.individual));
                        if (resp1.corpgrp != "0") setPickedCorporate(JSON.parse(resp1.corporate));
                        //setReqPaymentApproved
                        Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', resp1.req_purpose], function (result4) {
                            let resp4 = JSON.parse(result4);
                            setDdReqDocOptions(resp4);
                        });
                        Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttallsub', resp1.req_purpose], function (result) {
                            setDdReqSubPurposeOptions(JSON.parse(result));
                        });

                    });
                } else {
                    navigate('/'); // no query right
                }
                Common.callApi(Common.apiPanRelation, [sid, 'ddlistjson'], function (result) {
                    setDdReqPanRelationOptions(JSON.parse(result));
                });
                Common.callApi(Common.apiRight, [sid, 'all', 'MKCHANGEQTY'], function (result1) {
                    setRightChngQty(JSON.parse(result1));
                });
                Common.callApi(Common.apiRight, [sid, 'all', 'PAYMENTGATEWAY'], function (result1) {
                    setRightPg(JSON.parse(result1));
                });
                Common.callApi(Common.apiRight, [sid, 'all', 'PAYMENTLINKREQUEST'], function (result1) {
                    setRightPaymentLinkRequest(JSON.parse(result1));
                });
                Common.callApi(Common.apiCashFree, [sid, 'cashfreebanklist'], function (result) {
                    setDdReqRemitterBankOptions(JSON.parse(result));
                });
                Common.callApi(Common.apiPurpose, [sid, 'ddlistjsontt'], function (result) {
                    setDdReqPurposeOptions(JSON.parse(result));
                });


            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    useEffect(() => {
        if (!Common.showPickList || !onceRun) return;
        if (reqSellRate > 0 && reqData.req_quantity > 0 && reqBranch && reqData.req_srno > 0) {
            const obj = {
                reqSellRate: reqSellRate,
                reqQuantity: reqData.req_quantity,
                reqPurpose: (reqPurpose === "" ? 0 : reqPurpose),
                loan: (reqSourceOfFund === "S" ? "N" : "Y"),
                reqPan: reqPan,
                reqRemitterType: reqRemitterType,
                pickedCorporate: pickedCorporate,
                reqBranch: reqBranch,
                reqBankChargesInr: (reqBankChargesInr === "" ? 0 : reqBankChargesInr * 1),
                reqNostroChargesInr: (reqNostroChargesInr === "" ? 0 : reqNostroChargesInr * 1),
                reqTcsSelfDecInr: (reqTcsSelfDecInr === "" ? 0 : reqTcsSelfDecInr * 1),
                reqSourceOfFund: (reqSourceOfFund === "" ? "S" : reqSourceOfFund),
                reqDisbAmount: (reqDisbAmount === "" ? 0 : reqDisbAmount),
                srno: reqData.req_srno,
            }
            Common.callApi(Common.apiInProgress, [sid, "getcharges", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                setReqIgstInr(resp.igst);
                setReqCgstInr(resp.cgst);
                setReqSgstInr(resp.sgst);
                //setReqUgstInr(resp.ugst);
                setReqTCSInr(resp.tcs);
                setReqTCSRate(resp.tcsRate);
                setReqTCSTaxable(resp.tcsTaxable);
                setReqGstInr(resp.igst + resp.sgst + resp.cgst);
                setForexAmount(resp.forex);
                setTotalInr(resp.totalinr)
                setReqRoundOff(resp.roundoff);
                setReqGstTaxableValue(resp.gstTaxable);
            });
        }
    }, [reqSellRate, reqData.req_quantity, reqPurpose, reqSourceOfFund, reqPan, reqRemitterType,
        pickedCorporate, reqBranch, reqBankChargesInr, reqNostroChargesInr, pickedIndividual,
        reqTcsSelfDecInr, reqDisbAmount, reqData.req_srno, sid, onceRun
    ])

    function btnBackClick() {
        props.callInProgress();
    }

    function btnDraftClick() {
        saveCharges("D", false);
    }

    function btnFinalClick() {
        $('.loader').show();
        var msg = [], i = 0;
        if (reqRemitterName === ""
            || (reqData.req_quantity * 1 > 0 && (reqSellRate === "" || reqSellRate * 1 === 0))
            || reqPan === "" || reqPanRelation === "0"
            || (reqRemitterType === "I" && reqNameOnPan === "")
            || reqNostroType === "0" || reqNostroType === ""
            || (reqSourceOfFund === "L" && (reqDisbInstName === "" || reqDisbAmount === ""))
            || !Common.validatePanFlag(reqPan)
            || (reqRemitterDob >= (new Date()))
            || (Common.showPickList && ((reqRemitterType === "I" && pickedIndividual == null)
                || (reqRemitterType === "C" && pickedCorporate == null)))
            || (reqPurpose === "13" && reqSubPurpose === "0")
            || reqPurpose === "0"
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqPurpose === "0" ? " Purpose " : '');
            msg[i++] = (reqPurpose === "13" && reqSubPurpose === "0" ? " Sub Purpose Code " : '');

            msg[i++] = (reqRemitterName === "" ? " Remitter Name " : '');
            msg[i++] = ((reqRemitterDob >= (new Date())) ? " Invalid Date of birth " : '');

            msg[i++] = (reqSellRate === "" || reqSellRate * 1 === 0 ? " Sale Rate " : '');
            msg[i++] = (!Common.validatePanFlag(reqPan) ? "Invalid PAN" : '');
            msg[i++] = ((reqRemitterType === "I" && reqNameOnPan === "") ? "Name of PAN" : '');

            msg[i++] = (reqPanRelation === "0" ? "PAN Relationship" : '');

            msg[i++] = (reqNostroType === "0" || reqNostroType === "" ? "Nostro Type" : '');
            msg[i++] = ((reqSourceOfFund === "L" && reqDisbInstName === "") ? "Loan Institution Name" : '');
            msg[i++] = ((reqSourceOfFund === "L" && (reqDisbAmount === "" || reqDisbAmount * 1 <= 0)) ? "Loan Disbursment Amount" : '');



            if (Common.showPickList) {
                msg[i++] = ((reqRemitterType === "I" && pickedIndividual == null) ? " Please select individual" : '');
                msg[i++] = ((reqRemitterType === "C" && pickedCorporate == null) ? " Please select corporate" : '');
            }

            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            //saveCharges("D");
        } else {
            $('.loader').hide();
            setShowConfirmBox(true);
            /*if (window.confirm('Are you sure to lock the charges ? Locked charges can not be modified.')) {
                saveCharges("F");
            } else {
                saveCharges("D");
            }*/
        }
    }

    function saveCharges(saveMode, issavecorpindividualrisk) {
        setShowConfirmBox(false);
        $('.loader').show();

        var remittdob = reqRemitterDob.toString();
        remittdob = remittdob.replace("00:00:00 GMT+0530", "05:30:00 GMT+0530");
        setReqRemitterDob(new Date(remittdob));

        var isOk = 0;
        if (acRemark === '' && issavecorpindividualrisk === true) {
            setShowModal(false);
            setMsgText('Please fill Remark!');
            setMsgBox(true);
            $(".loader").hide();
        }
        else if (isOk === 0) {
            setShowModal(false);
            setReqTCSInr(((reqTCSInr === "") ? 0 : reqTCSInr));
            setReqBankChargesInr(((reqBankChargesInr === "") ? 0 : reqBankChargesInr));
            setReqNostroChargesInr(((reqNostroChargesInr === "") ? 0 : reqNostroChargesInr));
            setReqGstInr(((reqGstInr === "") ? 0 : reqGstInr));

            var object1 = {
                type: 'TCS_GST_CHARGES',
                reqQuantity: reqData.req_quantity,
                srno: reqData.req_srno,
                reqBranch: reqBranch,
                saveMode: saveMode,
                reqTCSInr: (reqTCSInr === "" ? 0 : reqTCSInr),
                reqBankChargesInr: (reqBankChargesInr === "" ? 0 : reqBankChargesInr),
                reqNostroChargesInr: (reqNostroChargesInr === "" ? 0 : reqNostroChargesInr),
                reqGstInr: (reqGstInr === "" ? 0 : reqGstInr),
                reqRoundOff: (reqRoundOff === "" ? 0 : reqRoundOff),
                reqRemitterType: reqRemitterType,
                reqRemitterName: reqRemitterName,
                reqRemitterDob: Common.dateYMD(new Date(remittdob)),
                reqNostroType: reqNostroType,
                reqSellRate: (reqSellRate === "" ? 0 : reqSellRate),
                reqPan: reqPan,
                reqNameOnPan: reqNameOnPan,
                reqPanRelation: reqPanRelation,
                reqPanOthRelation: reqPanOthRelation,
                reqItr2Year: reqItr2Year,
                reqSourceOfFund: reqSourceOfFund,
                reqDisbInstName: reqDisbInstName,
                reqDisbAmount: (reqDisbAmount === "" ? 0 : reqDisbAmount),
                reqMobile: reqMobile,
                reqEmail: reqEmail,
                reqRemitterAcctNo: reqRemitterAcctNo,
                reqRemitterAcctIfsc: reqRemitterAcctIfsc,
                reqRemitterBankCode: reqRemitterBankCode,
                reqPurpose: reqPurpose,
                reqSubPurpose: reqSubPurpose,
                reqPanFatherName: reqPanFatherName,
                pickedIndividual: pickedIndividual,
                pickedCorporate: pickedCorporate,
                showpicklist: Common.showPickList,
                reqCgstInr: reqCgstInr,
                reqSgstInr: reqSgstInr,
                reqIgstInr: reqIgstInr,
                reqTCSRate: reqTCSRate,
                reqTCSTaxable: reqTCSTaxable,
                reqRemitterAddress: reqRemitterAddress,
                reqRemitterCity: reqRemitterCity,
                reqRemitterIdType: reqRemitterIdType,
                reqRemitterIdNo: reqRemitterIdNo,
                reqTcsSelfDecInr: (reqTcsSelfDecInr === "" ? 0 : reqTcsSelfDecInr),
                reqGstTaxableValue: reqGstTaxableValue,
                totalInr: totalInr,
                issavecorpindividualrisk: issavecorpindividualrisk,
                riskValue: riskValue,
                riskRemark: acRemark,
                reqExecutive: executiveId || 0,
                reqExcecutiveName: executiveName || '',
                reqSubExecutive: subExecutiveId || 0,
                reqSubExcecutiveName: subExecutiveName || '',
                reqRemPan: reqRemPan || ''
            }
            Common.callApi(Common.apiCharges, [sid, 'save', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.blacklistedYN?.isBlackListed && resp.blacklistedYN.isBlackListed === "1") {
                    setMsgText(resp.blacklistedYN.name + " can't saved.Individual/Corporate is BLACKLISTED." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id);
                    setMsgBox(true);
                    return;
                }
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    if (saveMode === "F") {
                        setReqTcsFinal(1);
                    }

                } else if (resp.msg['riskvalue'] === '2') {
                    setShowModal(true);
                    setRiskModalBoxText(resp.msg['ledgername'] + " is medium risk. Please take the extra documentation.");
                    setRiskValue(resp.msg['riskvalue']);
                } else if (resp.msg['riskvalue'] === '3') {
                    setMsgBox(true);
                    setMsgText(resp.msg['ledgername'] + " is high risk.\nTransaction can not be saved.\n Please contact to compliance department.");
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function handlePaymentLinkClick() {
        $('.loader').show();
        var msg = [], i = 0;
        setShowPaymentLinkBox(false);
        Common.callApi(Common.apiCharges, [sid, 'sendpaymentlink', reqData.req_srno], function (result) {
            let resp = JSON.parse(result);

            if (resp.err === "") {
                $('.loader').hide();
                // {"msg":"Payment link has been send successfully.","err":"","logmsg":"ORDERLOGED","mailmsg":"MAILSENT"}
                if (resp.logmsg !== "ORDERLOGED") {
                    msg[i++] = "Unable to write log. Please contact to administrator";
                }
                if (resp.mailmsg === "MAILSENT") {
                    msg[i++] = "Payment link has been sent successfully";
                } else {
                    msg[i++] = "Unable to send Payment link. Please contact to administrator";
                }

                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            } else {
                $('.loader').hide();
                setMsgText(resp.err);
                setMsgBox(true);
            }
        });
    }

    function btnSendPaymentLinkClick() {
        $('.loader').show();
        var msg = [], i = 0;
        if (reqEmail === "" || reqRemitterAcctIfsc === "" || reqRemitterAcctNo === "" || reqRemitterBankCode === "0"
            || reqRemitterBankCode === ""
            || (reqRemitterAcctIfsc !== "" && reqRemitterAcctIfsc.length !== 11)
        ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqEmail === "" ? " Remitter Email " : '');
            msg[i++] = (reqRemitterBankCode === "0" ? " Remitter Bank Name " : '');
            msg[i++] = (reqRemitterBankCode === "" ? " Remitter Bank Name " : '');
            msg[i++] = (reqRemitterAcctNo === "" ? " Remitter Account Number " : '');
            msg[i++] = (reqRemitterAcctIfsc === "" ? " Remitter IFSC " : '');
            msg[i++] = ((reqRemitterAcctIfsc !== "" && reqRemitterAcctIfsc.length !== 11) ? " Invalid Remitter IFSC " : '');

            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $('.loader').hide();
            setShowPaymentLinkBox(true);
        }
    }

    /*
    function getTotalReceivable() {
        var totalInv = 0;
        var roundInv = 0;
        var roundoff = 0;
        var totalgst = reqGstInr * 1;
        totalInv = ((reqSellRate * reqData.req_quantity).toFixed(2) * 1 + reqTCSInr * 1 + totalgst + reqBankChargesInr * 1 + reqNostroChargesInr * 1 + reqRoundOff * 1).toFixed(2);
        if (Common.showPickList) {
            totalgst = reqCgstInr + reqSgstInr + reqIgstInr
            totalInv = ((reqSellRate * reqData.req_quantity).toFixed(2) * 1 + reqTCSInr * 1 + totalgst + reqBankChargesInr * 1 + reqNostroChargesInr * 1).toFixed(2);
            roundInv = Math.round(totalInv);
            roundoff = (roundInv - totalInv).toFixed(2);
            if (!isNaN(roundoff) && typeof roundoff !== 'undefined') {
                console.log(roundoff);
                // setReqRoundOff(roundoff);
            }
            // if (typeof roundoff === 'number') {
            //     setReqRoundOff(roundoff);
            // }
            // console.log(roundoff);
        }
        return totalInv;
    }
    */
    //console.log(reqRoundOff);

    function updateCharges() {
        if (reqData.req_isd === backOfficeData.isd
            && reqData.req_quantity === backOfficeData.isdQty
        ) {
            // && (reqData.req_remittertype === 'C' || reqData.req_pan === backOfficeData.panNo)
            setReqTCSInr(calcTcs);
            //setReqBankChargesInr((calcSrvChrg * 1 + calcRoundOff * 1).toFixed(2));
            setReqBankChargesInr(calcSrvChrg);
            setReqRoundOff(calcRoundOff);
            setReqGstInr(calcGst);
            setReqNostroChargesInr(0);
            if (backOfficeData.clientTyp === "W") {
                setReqRemitterType("I");
            }
            if (backOfficeData.clientTyp === "C") {
                setReqRemitterType("C");
            }
            setReqRemitterName(Common.removeSpecialChar(backOfficeData.clientNm));

            setReqSellRate(backOfficeData.saleRate);
            setReqPan(backOfficeData.panNo);
            setReqNameOnPan(Common.removeSpecialChar(backOfficeData.panNameOn));
            setReqPanRelation(Common.getPanRelationCode(backOfficeData.panRelation));
            if (backOfficeData.loanAvailed === "Y") {
                setReqSourceOfFund("L");
            }
            if (backOfficeData.loanAvailed === "N") {
                setReqSourceOfFund("S");
            }
            setReqDisbInstName(Common.removeSpecialChar(backOfficeData.loanInstName1));
            setReqDisbAmount((backOfficeData.disbAmnt1) * 1 + (backOfficeData.disbAmnt2) * 1 + (backOfficeData.disbAmnt3) * 1);
            setReqItr2Year(backOfficeData.sLastYearItr);
            setReqNostroType(backOfficeData.nostroType);
            setReqNameOnPan(backOfficeData.nameOnPan);

            //getTotalReceivable();
            setShowFetchTransaction(false);
            var object1 = {
                reqSrno: reqData.req_srno,
                fxTranNo: fxTranNo
            }
            Common.callApi(Common.apiAddDetails, [sid, 'updatefetchbackoffice', JSON.stringify(object1)], function (result) {
            });
            setMsgText("Form Updated");
            setMsgBox(true);
            /* console.log(reqData, null, ' ');
            console.log('reqData.req_isd ' + reqData.req_isd);
            console.log('backOfficeData.isd ' + backOfficeData.isd);
            console.log('reqData.req_quantity ' + reqData.req_quantity);
            console.log('backOfficeData.isdQty ' + backOfficeData.isdQty);
            console.log('reqData.req_remittertype ' + reqData.req_remittertype);
            console.log('reqData.req_pan ' + reqData.req_pan);
            console.log('backOfficeData.panNo ' + backOfficeData.panNo);*/
        } else {
            alert("Can Not Update. ISD or Quantity not matched.");
            /*console.log('reqData.req_isd ' + reqData.req_isd);
            console.log('backOfficeData.isd ' + backOfficeData.isd);
            console.log('reqData.req_quantity ' + reqData.req_quantity);
            console.log('backOfficeData.isdQty ' + backOfficeData.isdQty);
            console.log('reqData.req_remittertype ' + reqData.req_remittertype);
            console.log('reqData.req_pan ' + reqData.req_pan);
            console.log('backOfficeData.panNo ' + backOfficeData.panNo);*/
        }
    }

    function btnFetchBackoffice() {
        if (fxTranNo === "") {
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: reqData.req_srno,
                backsrno: fxTranNo
            }
            Common.callApi(Common.apiBackoffice, [sid, 'fetch', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.recordfound === 1) {
                    setBackOfficeData(resp[0]);
                    var charges = resp.chargesTable;
                    var i, tcs = 0, srvchrg = 0, rndoff = 0, gst = 0;
                    for (i = 0; i < charges.length; i++) {
                        // console.log(charges[i].ch_desc + " : " + charges[i].ch_amount + " : " + charges[i].ch_code);
                        if (charges[i].ch_code === "61" || charges[i].ch_code === "62" || charges[i].ch_code === "63"
                            || charges[i].ch_code === "64" || charges[i].ch_code === "65" || charges[i].ch_code === "66"
                        ) {
                            tcs = tcs + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "31" || charges[i].ch_code === "32" || charges[i].ch_code === "33" || charges[i].ch_code === "34") {
                            gst = gst + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "1") {
                            srvchrg = srvchrg + charges[i].ch_amount * 1;
                        }
                        if (charges[i].ch_code === "999") {
                            rndoff = rndoff + charges[i].ch_amount * 1;
                        }
                    }
                    setCalcGst(gst);
                    setCalcTcs(tcs);
                    setCalcSrvChrg(srvchrg);
                    setCalcRoundOff(rndoff);
                    setOrderDate(resp[0].orderDate);
                    setShowFetchTransaction(true);
                    //console.log(resp[0].clientNm);
                } else {
                    setMsgText("Transaction not found.");
                    setMsgBox(true);
                }
            });
        }
    }

    function btnChangeQuantity() {
        setShowChangeQuantity(true);
    }

    function btnChangeQuantitySend() {
        if (reqNewQuantity * 1 >= 0) {
            var object1 = {
                srno: reqData.req_srno,
                newqty: reqNewQuantity
            }
            Common.callApi(Common.apiCharges, [sid, 'changecoverquantity', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    $('.loader').hide();
                    alert(resp.msg);
                    setShowChangeQuantity(false);
                } else {
                    $('.loader').hide();
                    alert(resp.err);
                }
            });
        } else {
            setMsgText("Please put a valid quantity.");
            setMsgBox(true);
        }
    }

    function btnUploadFile() {
        $('.loader').show();
        if (document.getElementById('fileToUpload').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
            if (reqDocId === "0") {
                $('.loader').hide();
                setMsgText("Please fill document name.");
                setMsgBox(true);
            } else if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else {
                var object1 = {
                    sid: sid,
                    uploadType: 'KYC',
                    srno: reqData.req_srno,
                    pageright: 'ADDDETAILS',
                    docid: reqDocId,
                    remark: reqDocRemark
                }
                Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
                    let resp = JSON.parse(result);
                    $('.loader').hide();
                    if (resp.error === "") {
                        setDocListData(resp.docdetail);
                        alert(resp.message);
                        setReqDocId("0");
                        setReqDocRemark("");
                    }
                });
            }
        }
    }

    function btnDeleteDocumentClick(srno, docid, filename) {
        var object1 = {
            srno: srno,
            filename: filename,
            docid: docid
        }
        Common.callApi(Common.apiInProgress, [sid, 'docremove', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.error === "") {
                alert(resp.message);
            } else {
                alert(resp.error);
            }
            setDocListData(resp.docdetail);
        });
    }

    function btnDocumentView(srno, filename) {
        $('.loader').show();
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {

        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnSendPaymentLinkReqClick() {
        $('.loader').show();
        var msg = [], i = 0;
        if (docListData.length === 0 || reqEmail === "" || reqRemitterAcctIfsc === "" || reqRemitterAcctNo === "" || reqRemitterBankCode === "0"
            || reqRemitterBankCode === ""
            || (reqRemitterAcctIfsc !== "" && reqRemitterAcctIfsc.length !== 11)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (reqEmail === "" ? " Remitter Email " : '');
            msg[i++] = (reqRemitterBankCode === "0" ? " Remitter Bank Name " : '');
            msg[i++] = (reqRemitterBankCode === "" ? " Remitter Bank Name " : '');
            msg[i++] = (reqRemitterAcctNo === "" ? " Remitter Account Number " : '');
            msg[i++] = (reqRemitterAcctIfsc === "" ? " Remitter IFSC " : '');
            msg[i++] = ((reqRemitterAcctIfsc !== "" && reqRemitterAcctIfsc.length !== 11) ? " Invalid Remitter IFSC " : '');
            msg[i++] = (docListData.length === 0 ? " Scanned Cheque  " : '');
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        if (i === 0) {
            Common.callApi(Common.apiCharges, [sid, 'paymentlinkreq', reqData.req_srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    $('.loader').hide();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    $('.loader').hide();
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    const handleRemitterTypeChange = (v) => {
        setReqRemitterType(v);
        setPickedCorporate(null);
        setPickedIndividual(null);
        // console.log(v)
        // if (v === 'C') {
        setReqRemitterName('');
        setReqPan('')
        setReqNameOnPan('');
        setReqPanRelation(1)//1 mean self
        setReqRemitterDob(new Date());
        setReqRemitterAddress('');
        setReqRemitterCity('');
        setReqRemitterIdType(5);
        setReqRemitterIdNo('');
        setReqTcsSelfDecInr(0);
        // }
    }

    const handleCorporateValue = (value) => {
        setPickedCorporate(value);
        var val = value.id.split("^");
        setReqRemitterName(val[10]);
        // calculateCharges(value, "C");
        setReqPan(val[11])
        setReqNameOnPan(val[10]);
        let date = val[12];
        if (date) {
            setReqRemitterDob(new Date(date))
        } else {
            setReqRemitterDob(new Date())
        }
        setReqRemitterAddress(val[13]);
        setReqRemitterCity(val[14]);
        setReqRemitterIdType(5);
        setReqRemitterIdNo(val[11]);
    }

    const handleIndividualValue = (value) => {
        setPickedIndividual(value);
        var val = value.id.split("^");
        setReqRemitterName(val[3]);
        setReqPanRelation(1)//1 mean self
        setReqPan(val[4])
        setReqRemPan(val[4])
        setReqNameOnPan(val[3]);
        let date = val[6];
        console.log(date);
        if (date) {
            setReqRemitterDob(new Date(date))
        }
        setReqRemitterAddress(val[8]);
        setReqRemitterCity(val[9]);
        setReqRemitterIdType(5);
        setReqRemitterIdNo(val[4]);
        // calculateCharges(reqSellRate, "S");
    }

    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && pickedIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }

    const hideIndividualProfile = (val, individualsrno, blacklistedYN, master, dataid, name, idSrno = 0) => {
        setShowIndividualForm(val);
        if (blacklistedYN == '1') {
            setMsgText(name + " saved with BLACKLISTED individual." + master + " " + dataid);
            setMsgBox(true);
            setPickedIndividual(null);
            return;
        }
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                idSrno: idSrno,
                type: "PURCHASE"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                const desc = resp.desc.split("^");
                if (resp.id === "") setPickedIndividual(null);
                else handleNewIndiviualChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                // `${desc.slice(0, 3).join(" ")} ^ ${desc[3]} ^ ${desc.slice(4, 7).join(" ")}  ^    ${desc[7]}`
            });
        }
    }

    const handleNewIndiviualChange = (value) => {
        setPickedIndividual(value);
        var id = value.id.split("^");
        setReqRemitterName(id[3]);
        setReqPan(id[4])
        setReqNameOnPan(id[3]);
        setReqPanRelation(1)//1 mean self
        let date = id[5];
        if (date) {
            setReqRemitterDob(new Date(date))
        }
        setReqRemitterAddress(id[6]);
        setReqRemitterCity(id[7]);
        setReqRemitterIdType(5);
        setReqRemitterIdNo(id[4]);
        // setNIndivualSrno(id[1]);
        // setIndividualSelected(1);
        // setNCDFNum("");
    }

    // function calculateCharges(v, src) {
    //     //src = C : Corporate
    //     //src = S : Sellrate
    //     //src = L : Loan
    //     //src = B : bankcharges
    //     //src = N : Nostrocharges
    //     if (!Common.showPickList) return;
    //     const obj = {
    //         reqSellRate: src === "S" ? (v === "" ? 0 : v) : reqSellRate,
    //         reqQuantity: reqData.req_quantity,
    //         reqPurpose: src === "PR" ? (v === "" ? 0 : v) : (reqPurpose === "" ? 0 : reqPurpose),
    //         loan: (reqSourceOfFund === "S" ? "N" : "Y"),
    //         reqPan: reqPan,
    //         reqRemitterType: reqRemitterType,
    //         pickedCorporate: src === "C" ? v : pickedCorporate,
    //         reqBranch: reqBranch,
    //         reqBankChargesInr: src === "B" ? (v === "" ? 0 : v) : (reqBankChargesInr === "" ? 0 : reqBankChargesInr * 1),
    //         reqNostroChargesInr: src === "N" ? (v === "" ? 0 : v) : (reqNostroChargesInr === "" ? 0 : reqNostroChargesInr * 1),
    //         reqTcsSelfDecInr: src === "TS" ? (v === "" ? 0 : v) : (reqTcsSelfDecInr === "" ? 0 : reqTcsSelfDecInr * 1),
    //         reqSourceOfFund: (reqSourceOfFund === "" ? "S" : reqSourceOfFund),
    //         reqDisbAmount: src === "DA" ? (v === "" ? 0 : v) : (reqDisbAmount === "" ? 0 : reqDisbAmount),
    //         srno: reqData.req_srno,
    //     }
    //     Common.callApi(Common.apiInProgress, [sid, "getcharges", JSON.stringify(obj)], result => {
    //         let resp = JSON.parse(result);
    //         setReqIgstInr(resp.igst);
    //         setReqCgstInr(resp.sgst);
    //         setReqSgstInr(resp.sgst);
    //         //setReqUgstInr(resp.ugst);
    //         setReqTCSInr(resp.tcs);
    //         setReqTCSRate(resp.tcsRate);
    //         setReqTCSTaxable(resp.tcsTaxable);
    //         setReqGstInr(resp.igst + resp.sgst + resp.cgst);
    //         setForexAmount(resp.forex);
    //         setTotalInr(resp.totalinr)
    //         setReqRoundOff(resp.roundoff);
    //         setReqGstTaxableValue(resp.gstTaxable);
    //     });
    // }

    const panRelationHandler = (val) => {
        const value = val.target.value;
        setReqPanRelation(value)
        if (+value === 1) {
            let indiVal = pickedIndividual.id.split('^')
            setReqPan(indiVal[4])
            setReqNameOnPan(indiVal[3]);
            let date = indiVal[5];
            if (date) {
                setReqRemitterDob(new Date(date))
            }
        } else {
            //  setReqRemitterName('');
            setReqPan('')
            setReqNameOnPan('');
            setReqRemitterDob(new Date())
        }

    }

    function onChangePurpose(v) {
        setReqPurpose(v);
        setReqSubPurpose("0")
        Common.callApi(Common.apiPurpose, [sid, 'ddlistjsonttallsub', v], function (result) {
            setDdReqSubPurposeOptions(JSON.parse(result));
        });

    }

    const handlePickedExecutiveChange = (value) => {
        setPickedExecutive(value);
        const id = value?.id?.split('^');
        setExecutiveId(id[1]);
        setExecutiveName(id[2])
    }
    const handlePickedSubExecutiveChange = (value) => {
        setPickedSubExecutive(value);
        const id = value?.id?.split('^');
        setSubExecutiveId(id[1]);
        setSubExecutiveName(id[2])
    }
    const purposeHandler = (value) => {
        setReqPurpose(value)
        onChangePurpose(value)
    }
    const sourceOfFundHanlder = (value) => {
        setReqSourceOfFund(value)
        // calculateCharges(value, "")
    }
    const disbursadAmountHanlder = (value) => {
        Common.validateDecValue(value, setReqDisbAmount)
        //setReqSourceOfFund(value)
        // calculateCharges(value, "DA")
    }
    const handleBankChargesInr = (e) => {
        if (e.target.value) {
            let value = Math.round(e.target.value * 100) / 100;
            Common.validateDecValue(value, setReqBankChargesInr)
        } else {
            setReqBankChargesInr(0)
        }
    }
    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };

    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            {
                showIndividualForm ?
                    <Master_individual_profile reqObj={{ pickedIndividual: pickedIndividual, scrIndividual: scrIndividual }} value="IN_PROGRESS" hideIndividualProfile={hideIndividualProfile} />
                    :
                    <div className="divCostumForm">
                        <Container fluid>
                            <Row>
                                <Col>
                                    <h1>In Progress/Charges</h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <RequestHeaderMini rhdata={reqData}></RequestHeaderMini>
                                </Col>
                            </Row>
                            {
                                (reqTcsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1) && entityType === "B") ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>FXPLUS Transaction No : </Form.Label>
                                                    <Form.Control type="text" placeholder="Transaction No" maxLength={10} autoComplete="off"
                                                        value={fxTranNo}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setFxTranNo)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>&nbsp;</Form.Label><br></br>
                                                    <Button variant="outline-success" size="sm" onClick={(e) => btnFetchBackoffice()} >Fetch</Button>
                                                </Form.Group>
                                            </Col>
                                            <Col>&nbsp;</Col>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                    </>
                                    :
                                    <></>
                            }
                            <Row>
                                <Col className="col-md-3 col-6">
                                    <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        isDisabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={pickedExecutive}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchExecutivePicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handlePickedExecutiveChange}
                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                    >
                                    </AsyncSelect>
                                </Col>
                                <Col className="col-md-3 col-6">
                                    <Form.Label>Sub Executive</Form.Label>
                                    <AsyncSelect
                                        isDisabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={pickedSubExecutive}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchSubExecutivePicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handlePickedSubExecutiveChange}
                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                    >
                                    </AsyncSelect>
                                </Col>
                            </Row>
                            <Row>

                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Purpose <span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqPurpose}
                                            onChange={(e) => purposeHandler(e.target.value)} >
                                            <input type="text" />
                                            {ddReqPurposeOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {
                                    reqPurpose === "13" ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group >
                                                    <Form.Label>Sub Purpose <span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqSubPurpose}
                                                        onChange={(e) => setReqSubPurpose(e.target.value)}  >
                                                        <input type="text" />
                                                        {ddReqSubPurposeOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </> :
                                        null
                                }
                            </Row>
                            <Row>
                                <Col className='col-md-3'>
                                    <Form.Group>
                                        <Form.Label>Remitter Type<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqRemitterType}
                                            onChange={(e) => handleRemitterTypeChange(e.target.value)}
                                        >
                                            <option value="I">Individual</option>
                                            <option value="C">Entity</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col className='col-md-3'>
                                    <Form.Group>
                                        <Form.Label>Remitter Name<span className="mandatory">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="Remitter Name" maxLength={reqData.req_isd === "EUR" ? 35 : 100} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1) || Common.showPickList}
                                            value={reqRemitterName}
                                            onChange={(e) => Common.validateAlpNumPAN(e.target.value, setReqRemitterName)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                (reqRemitterType === "I" && Common.showPickList) ?
                                    <Row>


                                        <Col className='col-md-12'>
                                            <Form.Group>
                                                <Form.Label>Individual<span className='coloThemeRed'>*</span>
                                                    {
                                                        reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1) ?
                                                            null :
                                                            <>
                                                                <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                                &nbsp;&nbsp;
                                                                <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>
                                                            </>
                                                    }

                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={pickedIndividual}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchIndividualProfilePicklist} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    formatOptionLabel={Picklist.formatOptionLabel}
                                                    components={{ Menu: Picklist.menu }}
                                                    onChange={handleIndividualValue}
                                                    isDisabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}

                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    : (reqRemitterType === "C" && Common.showPickList) ?
                                        <Row>
                                            <Col className='col-md-12'>
                                                <Form.Group>
                                                    <Form.Label>Ledger</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={pickedCorporate}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE,DIVISION', 1 * reqBranch + 1001)} // location = 1 , 2
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleCorporateValue}
                                                        isDisabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        : null
                            }
                            <Row>
                                <Col>
                                    Full Address : {reqRemitterAddress} &nbsp; City : {reqRemitterCity}
                                </Col>

                                <Col>
                                    ID : {reqRemitterIdType} : {reqRemitterIdNo}
                                </Col>
                            </Row>

                            {
                                reqRemitterType === "I" || reqRemitterType === "C" ?
                                    <>
                                        <Row>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>PAN Relationship</Form.Label>
                                                    <Form.Select
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1) || reqRemitterType === 'C'}
                                                        value={reqPanRelation}

                                                        onChange={panRelationHandler} >
                                                        {ddReqPanRelationOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>PAN<span className="mandatory">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="PAN" maxLength={10} autoComplete="off"
                                                        disabled={1 * reqPanRelation === 1 || reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqPan} onChange={(e) => setReqPan(e.target.value.toUpperCase())}
                                                    />
                                                    {
                                                        /*
                                                        onBlur={(e) => Common.validatePan(e.target.value, setReqPan)}
                                                        */
                                                    }
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Name On PAN</Form.Label>
                                                    <Form.Control type="text" placeholder="Name on PAN" maxLength={reqData.req_isd === "EUR" ? 35 : 100} autoComplete="off"
                                                        disabled={(1 * reqPanRelation === 1 && reqRemitterType === "I") || reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqNameOnPan}
                                                        onChange={(e) => Common.validateAlpNumPAN(e.target.value, setReqNameOnPan)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>{reqRemitterType === "C" ? "Date of Inception" : " Date of Birth"}<span className="mandatory">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={reqRemitterDob}
                                                        onChange={(date) => setReqRemitterDob(date)}
                                                        isClearable={false}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        disabled={(1 * reqPanRelation === 1 && reqRemitterType === "I") || reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        customInput={
                                                            <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>

                                        </Row><Row>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Father's Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Name on PAN" maxLength={50} autoComplete="off"
                                                        value={reqPanFatherName}
                                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqPanFatherName)}
                                                        // disabled={(reqRemitterType === 'C' || (reqRemitterType === 'I' && reqPanRelation == 1))}
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1) || (reqRemitterType === 'C' || (reqRemitterType === 'I' && reqPanRelation == 1))}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Mobile No</Form.Label>
                                                    <Form.Control type="text" placeholder="Mobile No" maxLength={10} autoComplete="off"
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqMobile}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setReqMobile)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control type="email" placeholder="Email" maxLength={100} autoComplete="off"
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqEmail}
                                                        onChange={(e) => setReqEmail(e.target.value)}
                                                        onBlur={(e) => Common.validtateEmail(e.target.value, setReqEmail)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                {
                                                    (reqPanRelation === "11") ?

                                                        <Form.Group >
                                                            <Form.Label>Other Relationship</Form.Label>
                                                            <Form.Control type="text" placeholder="Other Relationship" maxLength={50}
                                                                disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                                value={reqPanOthRelation} onChange={(e) => setReqPanOthRelation(e.target.value)} autoComplete="off" />
                                                        </Form.Group>

                                                        : null
                                                }
                                            </Col>

                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>ITR 2 Years<span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        disabled={true || reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqItr2Year}
                                                        onChange={(e) => setReqItr2Year(e.target.value)}
                                                    >
                                                        <option value="1">Yes</option>
                                                        <option value="0">No</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group >
                                                    <Form.Label>Source of Fund<span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                        value={reqSourceOfFund}
                                                        onChange={(e) => { sourceOfFundHanlder(e.target.value) }}
                                                    >
                                                        <option value="S">Self</option>
                                                        <option value="L">Loan</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            {
                                                reqSourceOfFund === "S" ?
                                                    <>
                                                        <Col>&nbsp;</Col><Col>&nbsp;</Col>
                                                    </>
                                                    :
                                                    <>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Disbursed Institution Name<span className="mandatory">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Institution" maxLength={50} autoComplete="off"
                                                                    disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                                    value={reqDisbInstName}
                                                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqDisbInstName)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <Form.Group >
                                                                <Form.Label>Disbursed Amount<span className="mandatory">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Amount" maxLength={10} autoComplete="off"
                                                                    disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                                    value={reqDisbAmount}
                                                                    onChange={(e) => disbursadAmountHanlder(e.target.value)}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                            }
                                        </Row>
                                    </>
                                    : null
                            }
                            <Row>
                                <Col className='col-md-3'>
                                    <Form.Group >
                                        <Form.Label>Nostro Type<span className="mandatory">*</span></Form.Label>
                                        <Form.Select
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqNostroType}
                                            onChange={(e) => setReqNostroType(e.target.value)} >
                                            <option value="0" >Select</option>
                                            <option value="OUR">OUR</option>
                                            <option value="BEN">BEN</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3'>
                                    <Form.Group >
                                        <Form.Label>Sale Rate<span className="mandatory">*</span>{reqIsd} : {reqQuantity}</Form.Label>
                                        <Form.Control type="text" placeholder="Sale Rate" maxLength={10} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqSellRate}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqSellRate)}
                                        // onBlur={(e) => calculateCharges(e.target.value, "S")}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Bank Charges</Form.Label>
                                        <Form.Control type="text" placeholder="Bank Charges" maxLength={10} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqBankChargesInr}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqBankChargesInr)}
                                            onBlur={handleBankChargesInr}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Nostro Charges</Form.Label>
                                        <Form.Control type="text" placeholder="Nostro Charges" maxLength={10} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqNostroChargesInr}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqNostroChargesInr)}
                                        // onBlur={(e) => calculateCharges(e.target.value, "N")}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {
                                reqRemitterType === "I" ? <>
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>Others Forex Self Declaration:</Form.Label>
                                                <Form.Control type="text" placeholder="Others Forex Self Declaration" maxLength={10} autoComplete="off"
                                                    disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                                    value={reqTcsSelfDecInr}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqTcsSelfDecInr)}
                                                // onBlur={(e) => calculateCharges(e.target.value, "TS")}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </> : null
                            }
                            <Row>

                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>TCS</Form.Label>
                                        <Form.Control type="text" placeholder="TCS" maxLength={10} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || Common.showPickList || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqTCSInr}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqTCSInr)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className={Common.showPickList && 'divHide'}>
                                    <Form.Group >
                                        <Form.Label>GST</Form.Label>
                                        <Form.Control type="text" placeholder="GST" maxLength={10} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqGstInr}
                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqGstInr)}
                                        />
                                    </Form.Group>
                                </Col>
                                {
                                    Common.showPickList &&
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>CGST</Form.Label>
                                                <Form.Control type="text" placeholder="CGST" maxLength={10} autoComplete="off"
                                                    disabled
                                                    value={reqCgstInr}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqCgstInr)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>SGST</Form.Label>
                                                <Form.Control type="text" placeholder="SGST" maxLength={10} autoComplete="off"
                                                    disabled
                                                    value={reqSgstInr}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqSgstInr)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group >
                                                <Form.Label>IGST</Form.Label>
                                                <Form.Control type="text" placeholder="IGST" maxLength={10} autoComplete="off"
                                                    disabled
                                                    value={reqIgstInr}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqIgstInr)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                }
                                <Col className='col-md-3 col-6'>
                                    <Form.Group >
                                        <Form.Label>Round Off</Form.Label>
                                        <Form.Control type="text" placeholder="Round Off" maxLength={10} autoComplete="off"
                                            //disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            disabled
                                            value={reqRoundOff}
                                            onChange={(e) => Common.validateDecValueNegative(e.target.value, setReqRoundOff)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {
                                        Common.showPickList ?
                                            <span>Forex : {(reqSellRate * reqData.req_quantity).toFixed(0)}&nbsp;&nbsp;&nbsp;</span>
                                            : <span>Forex : {(reqSellRate * reqData.req_quantity).toFixed(2)}&nbsp;&nbsp;&nbsp;</span>
                                    }
                                    {/* Forex : {(reqSellRate * reqData.req_quantity).toFixed(2)}&nbsp;&nbsp;&nbsp; */}
                                    TCS : {reqTCSInr}&nbsp;&nbsp;&nbsp;
                                    GST : {reqGstInr}&nbsp;&nbsp;&nbsp;
                                    Bank Charges : {reqBankChargesInr}&nbsp;&nbsp;&nbsp;
                                    Nostro : {reqNostroChargesInr}&nbsp;&nbsp;&nbsp;
                                    <span>Round Off : {reqRoundOff}&nbsp;&nbsp;&nbsp;</span>
                                    Total : <b>{totalInr}</b>
                                    {/* Total : <b>{getTotalReceivable()}</b> */}
                                </Col>
                            </Row>
                            {
                                Common.showPickList ? <>
                                    <Row>
                                        <Col>
                                            GST Taxable : {reqGstTaxableValue} &nbsp; TCS Taxable : {reqTCSTaxable}
                                        </Col>
                                    </Row>
                                </> : null
                            }
                            <Row><Col>&nbsp;</Col></Row>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Client Bank</Form.Label>
                                        <Form.Select
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqRemitterBankCode}
                                            onChange={(e) => setReqRemitterBankCode(e.target.value)}  >
                                            {reqRemitterBankOptions.map((res) =>
                                                <option key={res.value} value={res.value}>{res.name}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Client Bank Account Number</Form.Label>
                                        <Form.Control type="text" placeholder="Account Number" maxLength={50} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqRemitterAcctNo}
                                            onChange={(e) => Common.validateNumValue(e.target.value, setReqRemitterAcctNo)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Client Bank IFSC </Form.Label>
                                        <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                            disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                            value={reqRemitterAcctIfsc}
                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterAcctIfsc)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>&nbsp;</Col>
                            </Row>
                            {
                                reqTcsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1) ? <>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Document Name</Form.Label>
                                                <Form.Select
                                                    value={reqDocId}
                                                    onChange={(e) => setReqDocId(e.target.value)}
                                                >
                                                    {ddReqDocOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Remark</Form.Label>
                                                <Form.Control type="text" value={reqDocRemark}
                                                    onChange={(e) => setReqDocRemark(e.target.value)}
                                                ></Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId='fileToUpload'>
                                                <Form.Label>File (Max 10MB)</Form.Label>
                                                <Form.Control type="file"></Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>&nbsp;</Form.Label><br></br>
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile()} >Upload</Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                </> : <>
                                </>
                            }
                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>

                                    <Table responsive striped bordered hover>
                                        <thead>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td>Type</td>
                                                <td>Remark</td>
                                                <td>File Name</td>
                                                 <td>Upload Timestamp</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {docListData.map((res) =>
                                                <tr key={res.doc_filename}>
                                                    <td>
                                                        {
                                                            reqTcsFinal * 1 === 0 && res.doc_approved * 1 === 0 ?
                                                                <>
                                                                    <div className="colorThemeBlue">
                                                                        <span className="handCursor" onClick={(e) => btnDeleteDocumentClick(res.doc_srno, res.doc_id, res.doc_filename)}>
                                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                                        </span>
                                                                    </div>
                                                                </>
                                                                : null
                                                        }

                                                    </td>
                                                    <td className='divHide'>{res.doc_srno}</td>
                                                    <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                                    <td>{res.doc_remark}</td>
                                                    <td>{res.doc_aws == 1 ? res.doc_aws_path : res.doc_filename}</td>
                                                     <td>{res.doc_uploadedat}</td>
                                                    <td>
                                                        <div className="colorThemeBlue">
                                                            {
                                                                (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                                    || res.doc_ext === "jpg" || res.doc_ext === "png")) ? <>
                                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>&nbsp;
                                                                </> : null
                                                            }

                                                            {(res.doc_aws == 1 &&
                                                            (
                                                                res.doc_ext === "pdf" ||
                                                                res.doc_ext === "jpeg" ||
                                                                res.doc_ext === "gif" ||
                                                                res.doc_ext === "jpg" ||
                                                                res.doc_ext === "png"||
                                                                res.doc_ext === "webp"
                                                            )) && (
                                                                <span
                                                                    onClick={() => Common.viewUploadedDocument(res.doc_aws_path,sid,openDocument)}
                                                                    className="pointer colorThemeBlue"
                                                                >
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            )}
                                                                
                                                                &nbsp;&nbsp;
                                                            {res.doc_aws == 1 ? (
                                                                <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                                    <FontAwesomeIcon icon={faFileDownload} />

                                                                </span>
                                                            ) :

                                                                <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                                    <FontAwesomeIcon icon={faFileDownload} />
                                                                </span>}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>




                            <Row>
                                <Col>
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                                    {
                                        (reqTcsFinal * 1 === 0 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                                            <>
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnDraftClick()} >Draft</Button>&nbsp;
                                                <Button variant="outline-success" size="sm" onClick={(e) => btnFinalClick()} >Final</Button>&nbsp;

                                            </>
                                            : null
                                    }
                                    {
                                        (reqTcsFinal * 1 === 0 && rightChngQty.query * 1 === 1 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                                            <>
                                                <Button variant="outline-danger" size="sm" onClick={(e) => btnChangeQuantity()} >Change Quantity</Button>&nbsp;
                                            </>
                                            : null
                                    }
                                    {
                                        (rightPaymentLinkReq.query * 1 === 1 && reqTcsFinal * 1 === 1 && (userRight.add * 1 === 1 || userRight.edit * 1 === 1)) ?
                                            <><Button variant="outline-success" size="sm" onClick={(e) => btnSendPaymentLinkReqClick()} >Request Payment Link</Button>&nbsp;</>
                                            : null
                                    }
                                    {
                                        (rightPg.query * 1 === 1 && reqTcsFinal * 1 === 1) ?
                                            <><Button variant="outline-success" size="sm" onClick={(e) => btnSendPaymentLinkClick()} >Send Payment Link</Button>&nbsp;</>
                                            : null
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </div>
            }
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <>
                            <h4>{riskModalBoxText}</h4>
                            <Form.Group>
                                <Form.Label>Action Taken<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Reason" maxLength={499}
                                    value={acRemark}
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setAcRemark)}
                                    autoComplete="off"
                                    required />
                            </Form.Group>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => saveCharges('F', true)}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
     
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
            <Modal
                show={showFetchTransaction}
                onHide={() => setShowFetchTransaction(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title >
                        Backoffice Transaction Details:
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <b>Order No : {backOfficeData.orderNo} </b>
                        </Col>
                        <Col>
                            <b>Order Date : {orderDate.split('-').reverse().join('/')}</b>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>
                                ISD : {backOfficeData.isd}
                            </b>
                        </Col>
                        <Col>
                            <b>Quantity : {backOfficeData.isdQty}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>Remitter : {backOfficeData.clientNm} ({backOfficeData.panNo}) </b>
                        </Col>
                        <Col>
                            <b>
                                Beneficiary : {backOfficeData.beniName}
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>TCS : {calcTcs}</b>
                        </Col>
                        <Col>
                            <b>Service Charges : {calcSrvChrg}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>GST : {calcGst} </b>
                        </Col>
                        <Col>
                            <b>Round Off : {calcRoundOff}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={() => updateCharges()}>Update</Button>&nbsp;
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal
                show={showChangeQuantity}
                onHide={() => setShowChangeQuantity(false)}
                size="xl"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Change Cover Quantity
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <b>Refrence No : {reqData.req_refno}</b>
                        </Col>
                        <Col>
                            <b>ISD : {reqData.req_isd} ({reqData.req_tenure}) </b>
                        </Col>
                        <Col>
                            <b>Quantity : {reqData.req_quantity}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group >
                                <Form.Label>New Quantity after change</Form.Label>
                                <Form.Control type="text" placeholder="New Quantity" maxLength={20} autoComplete="off"
                                    disabled={reqTcsFinal * 1 === 1 || !(userRight.add * 1 === 1 || userRight.edit * 1 === 1)}
                                    value={reqNewQuantity}
                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqNewQuantity)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => btnChangeQuantitySend()} >Send Request</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Charges Final Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to lock the charges ? Locked charges can not be modified.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveCharges("F", false)} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => saveCharges("D", false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal
                show={showPaymentLinkBox}
                onHide={() => setShowPaymentLinkBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Send Payment Link
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            Are you sure to send payment link ?.
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => handlePaymentLinkClick()} >Yes</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => setShowPaymentLinkBox(false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Tcs_Gst_Charges;